/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, April 14th 2022, 4:50:50 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

export const IntersectionObserverTargetComponent = ({ children, itemsListLength, itemIndex, elementRef }) =>
  // Setting the last element as the target for the intersection observer
  itemsListLength === itemIndex + 1 ? <div ref={elementRef}>{children}</div> : <div>{children}</div>;
